
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/destinations/front",
      function () {
        return require("private-next-pages/destinations/front.mdx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/destinations/front"])
      });
    }
  